<template>
  <div>
    <div v-if="Lib.checkPower('beauty-3-ckgkjcxx2',2)" class="infoList_div">
      <div class="infoList">
        <h5>基本资料</h5>
        <h6>
          <div>姓名：</div>
          <p>{{ customerInfo.nickName || "--" }}</p>
        </h6>
        <h6>
          <div>手机号码：</div>
          <p>{{ customerInfo.phone ? Lib.starPhone(customerInfo.phone) : "--" }}</p>
        </h6>
        <h6>
          <div>性别：</div>
          <p>{{ customerInfo.sex || "--" }}</p>
        </h6>
        <h6>
          <div>顾客身份：</div>
          <p class>{{ customerInfo.cardNo ? '会员' : '非会员' }}</p>
        </h6>
        <h6>
          <div>生日日期：</div>
          <p>{{ customerInfo.birthday || "--" }}</p>
        </h6>
        <h6>
          <div>客户来源：</div>
          <p>{{ customerInfo.source || "--" }}</p>
        </h6>
        <h6>
          <div>注册时间：</div>
          <p>{{ customerInfo.createTime||'--' }}</p>
        </h6>

        <h6>
          <div>注册门店：</div>
          <p>{{ customerInfo.createShopName||'--' }}</p>
        </h6>

        <h6>
          <div>微信号：</div>
          <p>{{ customerInfo.wechat || "--" }}</p>
        </h6>

        <h6>
          <div>关注公众号时间：</div>
          <p>{{ customerInfo.subscribeDate || "--" }}</p>
        </h6>

        <h6>
          <div>所在地区：</div>
          <p>{{ customerInfo.province?(customerInfo.province +customerInfo.city+(customerInfo.area ? customerInfo.area : '')):"--" }}</p>
        </h6>
        <h6>
          <div>详细地址：</div>
          <p>{{ customerInfo.address || "--" }}</p>
        </h6>
        <h6>
          <div>备注：</div>
          <p>{{ customerInfo.remark || "--" }}</p>
        </h6>
        <div class="upload">
          <div style="float: left;">
            <div v-for="(a,b) in customerInfo.images" :key="b" class="img">
              <el-image style="width: 60px;height: 60px;" :src="a" :preview-src-list="customerInfo.images" />
            </div>
          </div>
          <div style="float: left;">
            <div v-for="(file,index) in customerInfo.accessory" :key="index" class="img">
              <div class="file-attachments" :title="file.fileName">
                <svg aria-hidden="true" class="icon" style="width: 60px; height: 60px;">
                  <use :xlink:href="getTypeOfFile(file.fileType)" />
                </svg>
                <div class="file-attachments-wrap">
                  <i class="el-icon-zoom-in" @click="previewFile(file)" />
                  <i class="el-icon-download" @click="downLoadFile(file)" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="customerInfo.cardNo" class="infoList">
        <h5>会员信息</h5>
        <h6>
          <div>会员等级：</div>
          <p>{{ customerInfo.gradeName || "--" }}</p>
        </h6>
        <h6>
          <div>会员卡号：</div>
          <p>{{ customerInfo.cardNo || "--" }}</p>
        </h6>
        <h6>
          <div>余额：</div>
          <p>{{ customerInfo.money ? ('￥'+customerInfo.money) : "--" }}</p>
        </h6>
        <h6>
          <div>通用折扣：</div>
          <p>{{ customerInfo.discount ? (customerInfo.discount+'折') : "--" }}</p>
        </h6>
        <h6>
          <div>积分：</div>
          <p>{{ customerInfo.integral || "--" }}</p>
        </h6>
        <h6>
          <div>会员卡领取时间：</div>
          <p>{{ customerInfo.receiveDate || "--" }}</p>
        </h6>
        <h6>
          <div>会员卡办理门店：</div>
          <p>{{ customerInfo.cardShopName || "--" }}</p>
        </h6>
      </div>
    </div>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>

    <el-dialog close-on-press-escape custom-class="audio-player-dialog" :before-close="close" :visible.sync="audioDialog" width="528px" destroy-on-close :show-close="false">
      <aplayer ref="aplayer" :key="key" :music="playerOptions" class="audio-player" />
    </el-dialog>

    <el-dialog close-on-press-escape custom-class="video-player-dialog" :before-close="closeTwo" :visible.sync="videoDialog" width="728px" destroy-on-close :show-close="false">
      <video-player ref="videoPlayer" class="video-player vjs-custom-skin" :options="playerOptionsTwo" :playsinline="true" />
    </el-dialog>

    <el-dialog custom-class="txt-player-dialog" :before-close="closeThree" :visible.sync="txtDialog" width="728px" destroy-on-close :title="txtTitle">
      <div style="white-space: pre-wrap;height:600px;" v-text="txtData" />
    </el-dialog>

    <el-dialog custom-class="txt-player-dialog" :before-close="closeFour" :visible.sync="pdfDialog" width="728px" destroy-on-close :title="pdfTitle">
      <pdf v-if="loadError == false" style="width:100%;" :src="pdfData" @error="previewError" />
      <div v-else style="font-size: 16px;color: #666;text-align: center;padding: 50px 0 67px 0;">
        加载失败
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import '../../../../../assets/font/iconfont.js';
import Aplayer from 'vue-aplayer';
import { videoPlayer } from 'vue-video-player';
import 'video.js/dist/video-js.css';
import JsFileDownloader from 'js-file-downloader';
import pdf from 'vue-pdf';
import { Image } from 'element-ui';

Vue.use(Image);

export default {
  components: { Aplayer, videoPlayer, pdf },
  props: {
    customerInfo: {
      type: Object,
      default: Object
    } // 控制展示
  },
  data() {
    return {
      audioDialog: false,
      playerOptions: {
        src: '',
        title: '',
        artist: ''
      },
      key: null,

      videoDialog: false,
      playerOptionsTwo: {
        autoplay: false,
        controls: true,
        fluid: true,
        poster: '', // 封面地址
        sources: [],
        language: 'zh-CN',
        aspectRatio: '16:9',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        notSupportedMessage: '此视频暂无法播放，请稍后再试',
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },

      txtDialog: false,
      txtData: '',
      txtTitle: '',
      pdfDialog: false,
      pdfData: null,
      pdfTitle: '',
      loadError: false,
    };
  },
  methods: {
    // 获取文件类型
    getTypeOfFile(type) {
      switch (type) {
        case 'image':
          return '#icon-pic';
        case 'txt':
          return '#icon-txt';
        case 'compress':
          return '#icon-zip';
        case 'excel':
          return '#icon-excel';
        case 'word':
          return '#icon-word';
        case 'ppt':
          return '#icon-ppt';
        case 'video':
          return '#icon-mp4';
        case 'errVideo':
          return '#icon-mp4';
        case 'audio':
          return '#icon-voice';
        case 'pdf':
          return '#icon-pdf';
        default:
          return '#icon-N_A';
      }
    },
    // 文件下载 url下载地址, fileName文件名称, fileType文件类型
    downloadFile(url, fileName, fileType) {
      if (typeof dfAndroidAppHD !== 'undefined') {
        // 平板HD
        const imageType = ['jpg', 'png', 'jpeg', 'gif'];
        const isImage = imageType.some((str) => str === fileType);
        const type = isImage ? '1' : '2';
        window.dfAndroidAppHD.downloadFile(url, type, fileName);
      } else if (this.$isDesktop() === true) {
        // 客户端
        window.parent.postMessage({ command: 'addTaskUri', data: { url, fileName } }, '*');
      } else {
        new JsFileDownloader({
          url
        }).then((res) => {
          console.log(res);
        }).catch((error) => {
          console.log(error);
        });
        // downloadJs(url, fileName);
      }
    },
    // 附件预览
    async previewFile(file) {
      const { attachment, fileType, fileName } = file;
      const isSupport = await this.checkFileType(fileType); // 判断文件是否支持预览
      if (!isSupport) return false;
      if (fileType === 'video') {
        this.openTwo(attachment);
      } else if (fileType === 'audio') {
        this.open(fileName, attachment);
      } else if (fileType === 'pdf') {
        this.openFour(attachment, fileName);
      } else if (['word', 'excel', 'ppt'].some((e) => e === fileType)) {
        window.open(`http://view.officeapps.live.com/op/view.aspx?src=${attachment}`);
      } else {
        this.openThree(attachment, fileName);
      }
      return true;
    },
    // 下载附件
    downLoadFile(file) {
      const { attachment, fileName } = file;
      this.downloadFile(attachment, fileName);
    },
    // 检查预览附件格式支持
    checkFileType(fileType) {
      const allow = ['image', 'video', 'word', 'pdf', 'excel', 'txt', 'audio', 'ppt'];
      const has = allow.findIndex((type) => type === fileType);
      if (has === -1) {
        this.$message({ type: 'warning', message: '此文件类型，暂不支持预览' });
        return false;
      }
      return true;
    },
    open(name, url) {
      this.playerOptions.src = url;
      this.playerOptions.title = name;
      this.key = new Date().getTime();
      this.audioDialog = true;
    },
    close() {
      this.$refs.aplayer.pause();
      this.audioDialog = false;
    },
    openTwo(url) {
      const suffix = url.match(/.[^.]+$/)[0];
      const videoType = suffix.replace('.', '').toLowerCase();
      this.playerOptionsTwo.sources.push({ type: `video/${videoType}`, src: url });
      this.videoDialog = true;
    },
    closeTwo() {
      this.$refs.videoPlayer.player.pause();
      this.playerOptionsTwo.sources = [];
      this.videoDialog = false;
    },
    openThree(url, name) {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.onload = () => {
        const res = xhr.response;
        this.getTxtData(res, name);
      };
      xhr.onerror = () => {
        this.$msg.error('文件加载失败');
      };
      xhr.send();
    },
    openFour(url, name) {
      this.pdfDialog = true;
      this.pdfTitle = name;
      const loadingTask = pdf.createLoadingTask(url);
      loadingTask.promise.then(() => {
        this.loadError = false;
      }).catch(() => {
        this.loadError = true;
      });
      this.pdfData = loadingTask;
    },
    previewError() {
      this.loadError = true;
    },
    closeThree() {
      this.txtDialog = false;
    },
    closeFour() {
      this.pdfDialog = false;
    },
    // txt预览
    getTxtData(data, name) {
      this.txtDialog = true;
      this.txtTitle = name;
      const reader = new FileReader();
      reader.onload = (evt) => {
        this.txtData = evt.target.result;
      };
      reader.readAsText(data, 'utf-8');
      reader.onerror = () => {
        this.$msg.error('文件加载失败');
      };
    },
  }
};
</script>

<style lang="less" scoped>
.icon {
  fill: currentColor;
  overflow: hidden;
}
.infoList_div {
  display: flex;
  .infoList {
    width: 100%;
    color: #333333;
    .upload {
      float: left;
      padding-left: 55px;
      margin-top: -5px;
      .img {
        padding: 0 5px 10px 5px;
        float: left;
        .file-attachments {
          position: relative;
          overflow: hidden;
          width: 60px;
          height: 60px;
          border-radius: 4px;
          .file-attachments-wrap {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background-color: rgba(0,0,0,0.5);
            transition: all 0.3s;
            transform: scale(0);
            z-index: 10;
            color: #fff;
            padding: 0 8px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            box-align: center;
            box-pack: justify;
            justify-content: space-between;
            box-orient: horizontal;
            flex-direction: row;
            box-direction: normal;
            i {
              font-size: 18px;
              cursor: pointer;
            }
          }
          &:hover .file-attachments-wrap {
            transform: scale(1);
          }
        }
      }
    }
    h5 {
      font-size: 14px;
      margin: 15px 0;
      font-weight: 500;
      height: 15px;
      line-height: 15px;
      color: #999;
      padding-left: 15px;
    }
    h6 {
      font-size: 14px;
      color: #333;
      margin: 0 0 15px 0;
      // height: 15px;
      line-height: 20px;
      display: flex;
      div {
        max-width: 115px;
        padding-left: 18px;
        float: left;
        text-align: left;
        white-space: nowrap;
      }
      p {
        word-break: break-all;
      }
    }
  }
}
</style>

<style lang="less">
.video-player-dialog {
  background: none;
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-dialog__header {
    padding: 0;
    border-bottom: 0;
  }
  .vjs-custom-skin > .video-js .vjs-big-play-button {
    top: 50%;
    left: 50%;
    margin-left: -1.5em;
    margin-top: -1em;
    background-color: rgba(0, 0, 0, 0.45);
    font-size: 3.5em;
    height: 2em !important;
    line-height: 2em !important;
    margin-top: -1em !important;
  }
  .vjs-custom-skin > .video-js .vjs-play-progress,
  .vjs-custom-skin > .video-js .vjs-volume-level {
    background-color: #2483d5;
  }
  .video-js .vjs-play-progress:before {
    top: -4px;
  }
  .vjs-slider-horizontal .vjs-volume-level:before {
    top: -4px;
  }
  .vjs-custom-skin > .video-js .vjs-control-bar .vjs-time-control {
    min-width: 1em;
    padding: 0;
    margin: 0 0.1em;
    text-align: center;
    display: block;
  }
}
.audio-player-dialog {
  background: none;
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-dialog__header {
    padding: 0;
  }
  .audio-player {
    margin: 0;
  }
  .aplayer-time {
    & > button:first-of-type {
      display: none;
    }
  }
}
.txt-player-dialog {
  width: 100%;
}
</style>
